import images from './images';
import formSpree from './formspree';
import googleMapsAPI from './googleMaps'
import pdf from './pdf';

const config = { images, formSpree, googleMapsAPI, pdf };

export default config;